<template>
  <div>
    <v-row dense>
      <v-col
        cols="12"
        v-for="(campagne, index) in listOfCampagnes"
        :key="index"
      >
        <campagneCard
          class="mb-2"
          :amountOfUsers="campagne.amountOfUsers"
          :title="campagne.title"
          @setSnackbar="setSnackbar($event)"
        />
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="color" app>
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
      
      <script>
import campagneCard from "../shared/emailMarketing/CampagneCard.vue";
export default {
  data() {
    return {
      snackbar: false,
      text: "",
      color: "",
      listOfCampagnes: [
        {
          title: "Nieuwe brillen zijn binnen",
          amountOfUsers: "4500",
        },

        {
          title: "Nieuwe collectie zonnebrillen",
          amountOfUsers: "6842",
        },

        {
          title: "Reservebril",
          amountOfUsers: "2450",
        },
      ],
    };
  },
  created() {},
   components: {
   campagneCard
  },
  methods: {
    setSnackbar(event) {
      this.snackbar = true;
      this.text = event.text;
      this.color = event.color;
    },
  },
};
</script>
      
      <style>
</style>